export const RAPTOR_ITEM_CLICK_ENDPOINT = '/api/proxy/raptor/tracking/itemClick';
export const RAPTOR_SEARCH_ENDPOINT = '/api/proxy/raptor/tracking/search';
export const RAPTOR_PAGE_VIEW_ENDPOINT = '/api/proxy/raptor/tracking/pageView';
